import type { TScreenOrientation, TScreenRotation } from '@lucimark/shared/models/screen-rotation'

/**
 * Single source of truth for "is the window already portrait?" guards used by every layer that
 * can draw the boot / idle chrome (`#app-loading` inline script in index.html mirrors this logic,
 * see `window.__lucimarkApplyBootRotation`).
 *
 * On Device Owner / HDMI boxes (H96, user_rotation=1) MainActivity applies USER_ROTATION natively,
 * so the WebView window is already 720x1280. Applying the logical 90/270 swap (100vh x 100vw) or a
 * CSS rotation on top would centre content in a 1280x720 box and clip it on the right.
 */
export function isWindowPortrait(width: number, height: number): boolean {
  return width > 0 && height > 0 && height > width
}

export function isQuarterTurn(rotation: TScreenRotation | string | null | undefined): boolean {
  return rotation === '90' || rotation === '270'
}

/** Never swap dimensions or rotate a quarter turn when the window is already portrait. */
export function resolveWindowSafeRotation(
  rotation: TScreenRotation,
  orientation: TScreenOrientation,
  width: number,
  height: number
): { rotation: TScreenRotation, orientation: TScreenOrientation } {
  if (isWindowPortrait(width, height) && (isQuarterTurn(rotation) || orientation === 'vertical')) {
    return { rotation: '0', orientation: 'horizontal' }
  }
  return { rotation, orientation }
}
